/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const CustomerBalanceService = {

    async getSummary(customerCode, asOfDate) {
        var url = `api/CustomerBalance/${customerCode}`;

        if (asOfDate) {
            url += `?asOfDate=${asOfDate}`;
        }

        return await ApiService.get(url);
    },

    async getInvoices(customerCode, termType, term) {
        var url = `api/CustomerBalance/${customerCode}/Invoices?termType=${termType}&term=${term}`;

        return await ApiService.get(url);
    },
};

export { CustomerBalanceService };
